const DeactivationType = {
  DAILY: 'DAILY',
  CUSTOM: 'CUSTOM',
  PERMANENT: 'PERMANENT',
  // WEEKLY: 'WEEKLY',
}

export default DeactivationType
